export const DeveloperTemplates = {
  developer_user_create: "/templates/Preveil-Developer-User-Create-Template.csv",
};
